<template>
    <app-layout v-if="isPageReady" printClass="print-referral-listing">
        <common-content-spacer height="medium">
            <common-content-spacer height="small">
                <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>

                <common-page-header :heading="pageTitle"></common-page-header>
            </common-content-spacer>

            <common-page-plain>
                <common-content-spacer height="medium">
                    <referrals-pool-index-listing
                        :referrals="referrals"
                        :type="$route.params.type"
                        :filterOptions="[]"
                    ></referrals-pool-index-listing>

                    <common-buttons>
                        <common-button
                            v-if="referrals.length < referralsTotalCount"
                            :isProcessing="isSending"
                            :label="$t('pages.referrals.index.buttons.show_more')"
                            type="primary"
                            size="large"
                            @click="showMore()"
                        ></common-button>
                    </common-buttons>
                </common-content-spacer>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import ReferralsPoolAPI from 'api/ReferralsPoolAPI'
    import ReferralsPoolIndexListing from 'components/page-elements/referrals/ReferralsPoolIndexListing'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin],

        components: {
            AppLayout,
            ReferralsPoolIndexListing,
        },

        data() {
            return {
                referrals: [],
                offset: 0,
                referralsTotalCount: 0,
                isSending: false,
            }
        },

        provide() {
            return {
                isReferralPool: !!this.$route.params.type,
            }
        },

        computed: {
            pageTitle() {
                return this.$t(`pages.referrals.index.titles.${this.$route.params.type}`)
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.referrals.pool.breadcrumbs.referrals'),
                        route: { name: `referrals.${this.$route.params.type}` },
                    },
                    { label: this.$t(`pages.referrals.index.breadcrumbs.${this.$route.params.type}`) },
                ]
            },
        },

        methods: {
            loadReferrals(params) {
                this.isSending = true
                ReferralsPoolAPI.getReferralsPool(
                    this.$route.params.type,
                    this.$auth.getActiveMember() && this.$auth.getActiveMember()?.id
                        ? this.$auth.getActiveMember()?.id
                        : this.$auth.getUser().id,
                    params,
                )
                    .then((res) => {
                        this.referrals = this.referrals.concat(res)
                    })
                    .finally(() => {
                        this.isSending = false
                    })
            },

            showMore() {
                this.offset = this.offset + Number(this.$route.query.limit)
                this.loadReferrals({ ...this.$route.query, offset: this.offset })
            },

            getReferralsPool() {
                ReferralsPoolAPI.getReferralsPool(
                    this.$route.params.type,
                    this.$auth.getActiveMember()?.id ? this.$auth.getActiveMember()?.id : self.$auth.getUser().id,
                    { ...this.$route.query, offset: this.offset },
                ).then((response) => {
                    this.referralsTotalCount = response._headers['x-total-count']
                    this.referrals = response
                })
            },
        },

        watch: {
            referrals() {
                if (this.referrals._headers) {
                    this.referralsTotalCount = this.referrals._headers['x-total-count']
                }
            },

            $route() {
                this.referrals = []
                this.offset = 0
                this.getReferralsPool()
            },
        },

        mounted() {
            this.getReferralsPool()
        },
    }
</script>
